<template>
  <div class="space-y-3">
    <div v-if="events.length === 0" class="text-center py-8 text-gray-500">
      No scheduled events for today
    </div>
    <div 
      v-else
      v-for="event in events" 
      :key="event.time"
      class="flex items-center p-3 rounded-lg"
      :class="getEventClass(event.status)"
    >
      <div class="text-sm font-medium text-gray-600 w-20">{{ event.time }}</div>
      <div class="flex-1 ml-4">
        <p class="font-medium">{{ event.title }}</p>
      </div>
      <div :class="['badge badge-sm', getStatusBadge(event.status)]">
        {{ event.status }}
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  events: {
    type: Array,
    default: () => []
  }
})

function getEventClass(status) {
  return {
    'bg-green-50 border border-green-200': status === 'completed',
    'bg-blue-50 border border-blue-200': status === 'upcoming',
    'bg-yellow-50 border border-yellow-200': status === 'in-progress'
  }
}

function getStatusBadge(status) {
  return {
    'badge-success': status === 'completed',
    'badge-info': status === 'upcoming',
    'badge-warning': status === 'in-progress'
  }[status] || 'badge-secondary'
}
</script>